import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styles from './SystemsOverview.module.css';

import SystemCard from './SystemCard';
import { getAllSystems } from '../../api/bessService';

import Header from '../Shared/Header';
import { useTokenCheck } from '../../hooks/useTokenCheck';
import CenteredSpinner from '../Shared/CenteredSpinner';

export default function SystemsOverview() {
  useTokenCheck();
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const { systems, loading } = useSelector(
    (state) => state.bessReducer.overview
  );
  const organizationId = useSelector(
    (state) => state.userReducer.userOrganization
  );
  const isUserRepack = useSelector((state) => state.userReducer.isUserRepack);
  const [refreshData, setRefreshData] = useState(true);

  useEffect(() => {
    if (refreshData) {
      dispatch(getAllSystems(organizationId));
      setRefreshData(false);
    }
  }, [refreshData]);

  return (
    <div className={styles.container}>
      <Header
        title={t('yourSystems')}
        newButton={isUserRepack}
        onNewClicked={() => history.push('/addsystem')}
        refreshButton
        onRefreshClicked={() => setRefreshData(true)}
      />
      {loading ? (
        <CenteredSpinner />
      ) : (
        <div className={styles.systems}>
          {systems.map((system) => {
            return (
              <SystemCard
                systemOverview={system}
                key={system.name}
                id={system.name}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}
